/**
 * @generated SignedSource<<848a767515ceb643b8d8747615b53e0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultRenderer_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchAssetsObjectSchema_AtlassianSearchPage" | "searchAssetsObjectType_AtlassianSearchPage" | "searchAssetsObject_AtlassianSearchPage" | "searchAtlasGoal_AtlassianSearchPage" | "searchAtlasProject_AtlassianSearchPage" | "searchCompassComponent_AtlassianSearchPage" | "searchConfluencePageBlogAttachment_AtlassianSearchPage" | "searchConfluenceSpace_AtlassianSearchPage" | "searchDefaultRenderer_AtlassianSearchPage" | "searchFederatedResult_AtlassianSearchPage" | "searchGraphCode_AtlassianSearchPage" | "searchGraphResult_AtlassianSearchPage" | "searchJiraBoard_AtlassianSearchPage" | "searchJiraDashboard_AtlassianSearchPage" | "searchJiraFilter_AtlassianSearchPage" | "searchJiraIssue_AtlassianSearchPage" | "searchJiraPlan_AtlassianSearchPage" | "searchJiraProject_AtlassianSearchPage" | "searchMercuryFocusAreaUpdate_AtlassianSearchPage" | "searchMercuryFocusArea_AtlassianSearchPage" | "searchMercuryRisk_AtlassianSearchPage" | "searchPassionfruitAsk_AtlassianSearchPage" | "searchTalentPosition_AtlassianSearchPage" | "searchTrello_AtlassianSearchPage">;
  readonly " $fragmentType": "searchResultRenderer_AtlassianSearchPage";
};
export type searchResultRenderer_AtlassianSearchPage$key = {
  readonly " $data"?: searchResultRenderer_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultRenderer_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "includeIconUrl",
  "variableName": "includeIconUrl"
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "kind": "Variable",
    "name": "includeJiraLiteModeFields",
    "variableName": "includeJiraLiteModeFields"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssets"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeGithubCode"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeReactionsAndCommentCount"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeRisk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResultRenderer_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "searchAtlasGoal_AtlassianSearchPage"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "searchAtlasProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchFederatedResult_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchCompassComponent_AtlassianSearchPage"
    },
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "includeNavBoostScore",
          "variableName": "includeNavBoostScore"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "searchConfluenceSpace_AtlassianSearchPage"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeReactionsAndCommentCount",
          "variableName": "includeReactionsAndCommentCount"
        },
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchGraphResult_AtlassianSearchPage"
    },
    {
      "condition": "includeGithubCode",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchGraphCode_AtlassianSearchPage"
        }
      ]
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "searchJiraIssue_AtlassianSearchPage"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "searchJiraProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraPlan_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraBoard_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraDashboard_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraFilter_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchMercuryFocusArea_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage"
    },
    {
      "condition": "includeRisk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchMercuryRisk_AtlassianSearchPage"
        }
      ]
    },
    {
      "condition": "includePassionfruitAsk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchPassionfruitAsk_AtlassianSearchPage"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "searchTrello_AtlassianSearchPage"
    },
    {
      "condition": "includeAssets",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchAssetsObjectSchema_AtlassianSearchPage"
        },
        {
          "kind": "FragmentSpread",
          "name": "searchAssetsObjectType_AtlassianSearchPage"
        },
        {
          "kind": "FragmentSpread",
          "name": "searchAssetsObject_AtlassianSearchPage"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "searchDefaultRenderer_AtlassianSearchPage"
    },
    {
      "condition": "includePositions",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchTalentPosition_AtlassianSearchPage"
        }
      ]
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};
})();

(node as any).hash = "4259ff1e79a3ec69dc203e1b05f8505b";

export default node;
